import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["colorSelect"];

  connect() {
    if (this.colorSelectTargets.every((c) => c.disabled)) return;

    this.colorSelectTargets.forEach((select) => {
      $(select).on("change", (e) => this.toggleColorSelects());
    });

    this.toggleColorSelects();
  }

  toggleColorSelects() {
    this.colorSelectTargets.forEach((select, i) => {
      const $select = $(select);
      const $nextSelect = $(this.colorSelectTargets[i + 1]);

      if ($select.val()) {
        $select.prop("disabled", false);
        $nextSelect.prop("disabled", false);
      } else {
        $nextSelect.val("").trigger("change.select2");
        $nextSelect.prop("disabled", true);
      }
    });
  }
}
